import * as Types from '../types-api.generated';

import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiClearStagedAssetsVariables = Types.Exact<{
  collection: Types.ApiCollectionInput;
}>;


export type ApiClearStagedAssets = { clearStagedAssets: boolean };



export const ApiClearStagedAssetsDocument = /*#__PURE__*/ `
    mutation ClearStagedAssets($collection: CollectionInput!) {
  clearStagedAssets: clearStagedAssetsV2(collection: $collection)
}
    `;

export const useClearStagedAssets = <
      TError = ClientError,
      TContext = unknown
    >(options?: UseMutationOptions<ApiClearStagedAssets, TError, ApiClearStagedAssetsVariables, TContext>) => {
    
    return useMutation<ApiClearStagedAssets, TError, ApiClearStagedAssetsVariables, TContext>(
      {
    mutationKey: ['ClearStagedAssets'],
    mutationFn: (variables?: ApiClearStagedAssetsVariables) => apiFetcher<ApiClearStagedAssets, ApiClearStagedAssetsVariables>(ApiClearStagedAssetsDocument, variables)(),
    ...options
  }
    )};


useClearStagedAssets.fetcher = (variables: ApiClearStagedAssetsVariables, options?: RequestInit['headers']) => apiFetcher<ApiClearStagedAssets, ApiClearStagedAssetsVariables>(ApiClearStagedAssetsDocument, variables, options);
